/** Reference count — supports nested overlays without prematurely unlocking. */
let _count = 0;

export function lockScroll(): void {
  if (++_count === 1) document.body.style.overflow = 'hidden';
}

export function unlockScroll(): void {
  if (_count > 0 && --_count === 0) document.body.style.overflow = '';
}
